import React, { Component } from 'react';

import { Row, Col } from 'reactstrap';
import chroma from 'chroma-js';

export class EscalaColores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minimo: props.minimo,
      maximo: props.maximo
    };
  }

  render() {
    const minimo = this.state.minimo;
    const maximo = this.state.maximo;
    const escala = chroma
      .scale('YlGnBu')
      .correctLightness()
      .mode('lch')
      .domain([minimo.valor, maximo.valor]);
    const colores = escala.colors(8);
    let gradiente = `linear-gradient(to right, ${colores.reduce((pv, cv, i) => {
      return pv + (i === 0 ? '' : ', ') + cv;
    }, '')})`;
    return (
      <Col xs={12} className={this.props.className} style={this.props.style}>
        <Row>
          <div style={{ width: '100%', height: '1em', background: gradiente }} />
        </Row>
        <Row>
          <Col xs={6} style={{ textAlign: 'left', padding: 0 }}>
            {minimo.nombre}
          </Col>
          <Col xs={6} style={{ textAlign: 'right', padding: 0 }}>
            {maximo.nombre}
          </Col>
        </Row>
      </Col>
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.minimo !== nextState.minimo) {
      return true;
    }
    if (this.state.maximo !== nextState.maximo) {
      return true;
    }
    return false;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ minimo: nextProps.minimo, maximo: nextProps.maximo });
  }
}



// WEBPACK FOOTER //
// ./src/components/EscalaColores.js